export default __webpack_public_path__ + "static/sales-7dcc76d2222f99abfd59a29e24e7ab4a.png";